import React from 'react';
import { useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom'
import './AssoContactScreen.scss'
import { Fire, Tools, Popup, Time } from '../../services'

import { Label } from 'reactstrap'
import Switch from 'react-switch'
import Select from 'react-select'
import { Headerbar, NotifPreview, DocumentPicker, FormInput, HTMLEditor, YesNo, Loader, EditContainer, ImagesPicker } from '../Reusable'

import FadeIn from 'react-fade-in';

const { useHistory } = require('react-router-dom')

interface Props {
  match: any;
}
const AssoContactScreen: React.FC<Props> = (props) => {

  const [error, setError] = React.useState('')
  const [events, setPro] = React.useState<any[]>([])
  const history = useHistory()
  const user = useSelector(state => state.authReducer.user)
  const proId = props.match.params.proId

  React.useEffect(() => {
    retrieveData()
  }, [])

  const retrieveData = async () => {
    try {
      const proRef = Fire.store().collection('pros').doc(proId)
      const pro = await Fire.doc(proRef)
      setPro(pro)
    } catch (err) {
      console.log(err.message)
      setError('Vérifiez votre connexion internet')
    }
  }

  const onSave = async (item: any, pictures: any[]) => {}
  const onRemove = async (item: any) => {}

  const send = async (item: any) => {
    const confirm = window.confirm('Êtes-vous sûr de vouloir envoyer cette demande ?')
    if (!confirm)
      return;

    try {
      const payload: any = {
        ...item,
        senderId: user.id,
        receiverId: proId,
        asso: user,
        createdAt: new Date(),
      }

      payload.work = await Tools.uploadPicture('/pros/' + user.id + '/asso_work_' + Math.random() + '.png', item.work)
      const proRef = Fire.store().collection('pros').doc(proId)
      await proRef.collection('contacts').doc(user.id).set(payload)
      history.push('/partners')
    } catch (err) {
      console.warn(err)
    }
  }

  const onChangePicture = async (key: string, event: any, onChange: any) => {
    try {
      const url = await Tools.requestSmallImage(event)
      onChange(key, { url: url, saved: false })
    } catch (err) {
      alert(err.message)
    }
  }

  const canSend = (item: any) => {
    return (item.title && item.title.length &&
      item.message && item.message.length)
  }

  const wasRequired = (value: any) => {
    return value && value.length > 0
  }

  const updateErrors = (item: any) => {
    const errors: any = {}
    // Title check
    if (!wasRequired(item.title))
      errors.title = 'Champs obligatoire'
    // Message check
    if (!wasRequired(item.message))
      errors.message = 'Champs obligatoire'

    return errors
  }

  const renderContent = ({item, onChange, save, saving, errors, changed, setChanged}) => {
    return (
      <div className="card">
        <div className="card-header">
          <h3 className="card-title">Envoyer une demande de partenariat</h3>
        </div>

        <div className="card-body">
          
          <FormInput
            placeholder="Titre"
            value={item.title}
            error={errors.title}
            onChange={(evt) => onChange('title', evt.target.value)}
            />
          <FormInput
            textarea
            rows={3}
            error={errors.message}
            placeholder="Votre proposition"
            value={item.message}
            onChange={(evt) => onChange('message', evt.target.value)}
            />

          <DocumentPicker
            value={item.work}
            error={errors.work}
            title="Plaquette de présentation (optionel)"
            previewTitle='Plaquette'
            onChange={(url) => onChangePicture('work', url, onChange)}
            />

          <div className="centered">
            <button
              type="button"
              className="btn btn-danger"
              onClick={() => send(item)}
              disabled={saving || !canSend(item)}
              >
              { saving ? 'Chargement...' : 'Envoyer ma demande' }
            </button>
          </div>
        </div>
      </div>
    )
  }

  return (
    <EditContainer
      id={props.match.params.id}
      error={error}

      updateErrors={updateErrors}
      onSave={onSave}
      onRemove={onRemove}
      renderTitle={() => 'Nouvelle demande'}
      renderContent={renderContent}
      />
  );
}

export default withRouter(AssoContactScreen)
